document.addEventListener('DOMContentLoaded', function () {
  const stickyAtcBar = document.querySelector('.sticky-atc-bar');
  if (!stickyAtcBar) return;

  const scrollThreshold = 800; // Distance en pixels avant d'afficher la barre

  // `classList.add`/`remove` réécrivent l'attribut `class` même quand l'état est
  // inchangé : appelés à chaque événement de scroll, ils généraient une mutation du
  // DOM par pixel parcouru. On ne touche au DOM que sur un vrai changement d'état.
  let isInactive = null;

  function checkScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // Afficher la barre si on a scrollé plus que le seuil ET qu'on n'est pas tout en bas
    const shouldShow =
      scrollTop > scrollThreshold &&
      scrollTop + windowHeight < documentHeight - 50;

    if (isInactive === !shouldShow) return;
    isInactive = !shouldShow;
    stickyAtcBar.classList.toggle('inactive', isInactive);
  }

  // Vérifier au scroll
  window.addEventListener('scroll', checkScroll, { passive: true });

  // Vérifier au chargement initial
  checkScroll();
});
